const isPerformanceSection = (
  s: PerformanceBoardTypes.SlideOut.SlideOutSection,
): s is PerformanceBoardTypes.SlideOut.TargetProgressSection => {
  return s.sectionType === 'Target Progress';
};

export default isPerformanceSection;
